export type IssueForRelatedIssuesCount = {
  inspection?: string;
};

export function countInspectionRelatedIssues(
  inspectionId: string,
  issues: IssueForRelatedIssuesCount[]
): number {
  return issues.filter((issue) => issue.inspection === inspectionId).length;
}

export function createInspectionRelatedIssuesCountMap(
  issues: IssueForRelatedIssuesCount[]
): Map<string, number> {
  const counts = new Map<string, number>();
  for (const issue of issues) {
    if (!issue.inspection) continue;
    counts.set(issue.inspection, (counts.get(issue.inspection) ?? 0) + 1);
  }
  return counts;
}
